import React from "react";
import { Link, useParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const CountryDetail = () => {
  const { countryCode } = useParams();
  const countryLabel = countryCode ? countryCode.toUpperCase() : "Country";

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="country-detail-page">
        <h1 className="font-manrope font-bold text-3xl text-foreground mb-3" data-testid="country-detail-title">
          {countryLabel} Deep Dive
        </h1>
        <p className="text-sm text-muted-foreground mb-6" data-testid="country-detail-description">
          Detailed country analysis is coming soon. This space will provide deeper lifestyle, cost, and residency insights to support your final decision.
        </p>
        <Link
          to="/assessment-results"
          className="text-sm text-primary font-medium hover:underline"
          data-testid="country-detail-back-link"
        >
          Back to Assessment Results
        </Link>
      </main>
      <Footer />
    </div>
  );
};

export default CountryDetail;
